<template>
  <div class="home">
    <div class="grid gap-4 grid-cols-1 md:grid-cols-2 mb-4">
      <blog-post v-for="post in posts" :key="post.id" :post="post" />
      <!-- <card-tile
        v-for="post in posts"
        :key="post.id"
        :title="post.title"
        :summary="post.summary"
        :createdAt="post.created_at"
        :link="{ name: 'Blog.Read', params: { slug: post.slug } }"
      ></card-tile>-->
    </div>

    <button v-if="showMoreEnabled" @click="showMore">Show more</button>
  </div>
</template>

<script>
import gql from "graphql-tag";
import BlogPost from "@/components/Cards/BlogPost";

export default {
  name: "Blog",
  components: { BlogPost },
  data: function() {
    return {
      page: 0,
      showMoreEnabled: true
    };
  },
  apollo: {
    // Pages
    posts: {
      // GraphQL Query
      query: gql`
        query tagsPage($skip: Int!, $first: Int!) {
          posts(skip: $skip, first: $first) {
            id
            title
            slug
            summary
            createdAt
            categories {
              title
              slug
            }
          }
        }
      `,
      // Initial variables
      variables: {
        skip: 0,
        first: 12
      }
    }
  },
  methods: {
    showMore() {
      this.page++;
      // Fetch more data and transform the original result
      this.$apollo.queries.posts.fetchMore({
        // New variables
        variables: {
          skip: this.page * 12,
          first: 12
        },
        // Transform the previous result with new data
        updateQuery: (previousResult, { fetchMoreResult }) => {
          console.log(previousResult);
          console.log(fetchMoreResult);
          const newTags = fetchMoreResult.posts;

          this.showMoreEnabled = fetchMoreResult.posts.length > 0;

          return {
            posts: [...previousResult.posts, ...newTags]
          };
        }
      });
    }
  }
};
</script>
